import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';
import { isFuncComp } from '../../../../components/common/Helpers/index.js';

const reviewOrderPage = Loadable(() => (isFuncComp() ? import('../../FuncComponnetContainers/index') : import('../../containers/web/index')));

// const reviewOrderPage = Loadable(() => import('../../containers/web/reviewOrderPage'));
export default MapTo('vcg/components/soe-home/react/orderreview')(reviewOrderPage);
